import raportToRefreshReducer from './raportToRefresh.reducer';
import raportyReducer from './raporty.reducer';
import signalRTypReducer from './singalRReducer';

export default {
  signalRTyp: signalRTypReducer,
  raporty: raportyReducer,
  raportToRefresh: raportToRefreshReducer
};
